import AppTooltip from "./AppTooltip";

export type { AppTooltipProps } from "./AppTooltip";
export default AppTooltip;
